module.exports = __webpack_public_path__ + "static/media/proxxmu-hifi3.5dd14baf.png";